import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { UserResponse } from 'src/app/models/user-interests';
import { UserService } from '../user.service';

@Injectable({
  providedIn: 'root',
})
export class UserResponsesResolverService  {
  constructor(private _userService: UserService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserResponse[]> {
    return this._userService.getUserInterests();
  }
}
